import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import PropTypes from 'prop-types';
import {
    AppBar,
    Box,
    CssBaseline,
    Divider,
    Drawer,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Toolbar,
    Typography,
    Button,
    Avatar,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    mobileLinkActive: {
        backgroundColor: '#f4f4f4',
        borderRight: '5px solid #015fc9',
        color: '#015fc9'
    },

    link: {
        color: "#000",
        cursor: "pointer"
    },

    linkActive: {
        borderBottom: '3px solid #015fc9',
        color: '#015fc9',
        cursor: "pointer"
    }
})

const drawerWidth = 240;

const navItems = [
    {
        label: "Home",
        link: "/home"
    },
    {
        label: "About Us",
        link: "/about"
    },
    {
        label: "Contact Us",
        link: "/contact"
    }
];

function Header(props) {

    const location = useLocation();
    const navigate = useNavigate();

    const { logout, user, isAuthenticated } = useAuth0();

    const classes = useStyles();

    const { window } = props;
    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };

    const handleDrawerClose = () => {
        setMobileOpen((prevState) => !prevState)
    }

    const withoutNavigationBar = ["/welcome"];
    const { pathname } = useLocation();
    if (withoutNavigationBar.some((item) => pathname.includes(item))) {
        return null;
    }

    const drawer = (
        <Box
            onClick={handleDrawerToggle}
            sx={{ textAlign: 'center' }}
        >
            <Typography variant="h6" sx={{ my: 2 }}>
                Navbar
            </Typography>
            <Divider />
            <List>
                {navItems.map((item, index) => (
                    <ListItem
                        key={index + 1}
                        disablePadding
                        className={
                            location.pathname === item.link ? classes.mobileLinkActive : null
                        }
                        onClick={() => {
                            navigate(item.link);
                            handleDrawerToggle();
                            handleDrawerClose();
                        }}
                    >
                        <ListItemButton sx={{ textAlign: 'center' }}>
                            <ListItemText primary={item.label} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
            <Divider />
            <Box mt={2}>
                {
                    isAuthenticated && (
                        <Button
                            color="error"
                            variant='contained'
                            onClick={() => logout({ logoutParams: { returnTo: "https://auth0-authentication.vercel.app/welcome" } })}
                        >
                            Logout
                        </Button>
                    )
                }
            </Box>
        </Box>
    );

    const container = window === undefined ? undefined : () => window().document.body;

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar component="nav" sx={{ backgroundColor: "#eeeeee" }}>
                <Toolbar>
                    <IconButton
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ me: 2, display: { sm: 'none' } }}
                    >
                        <MenuIcon sx={{ color: "#000" }} />
                    </IconButton>
                    <Typography
                        variant="h6"
                        component="div"
                        sx={{ flexGrow: 1, display: { xs: 'block', sm: 'block' }, color: "#000" }}
                    >
                        Navbar
                    </Typography>
                    <Box
                        sx={{ display: { xs: 'none', sm: 'flex' }, gap: "1rem" }}
                    >
                        {navItems.map((item, index) => (
                            <Typography
                                key={index + 1}
                                className={
                                    location.pathname === item.link ? classes.linkActive : classes.link
                                }
                                onClick={() => navigate(item.link)}
                            >
                                {item.label}
                            </Typography>
                        ))}
                    </Box>
                    {
                        isAuthenticated && (
                            <Box sx={{ ml: 2 }}>
                                <Avatar>
                                    {user?.name?.charAt(0)}
                                </Avatar>
                            </Box>
                        )
                    }
                    <Box mx={2}>
                        {
                            isAuthenticated && (
                                <Button
                                    color="error"
                                    variant='contained'
                                    onClick={() => logout({ logoutParams: { returnTo: "https://auth0-authentication.vercel.app/welcome" } })}
                                >
                                    Logout
                                </Button>
                            )
                        }
                    </Box>
                </Toolbar>
            </AppBar>
            <Box component="nav">
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth }
                    }}
                >
                    {drawer}
                </Drawer>
            </Box>
            <Box component="main" sx={{ p: 1 }}>
                <Toolbar />
            </Box>
        </Box >
    );
}

Header.propTypes = {
    window: PropTypes.func,
};

export default Header;